import { initialSurveyState, SurveyActionTypes } from '../types';
import createAsyncMapReducer from '~lib/shared/redux/reducers/async-map-reducer';
const listSurveysByUserIdReducer = createAsyncMapReducer(SurveyActionTypes.LIST_SURVEYS_BY_USER_ID, initialSurveyState.listSurveysByUserId);
export default listSurveysByUserIdReducer;
